import React, {Component} from "react";
import EventHeader from "./EventHeader";

class Sport extends Component {
	render() {
		const {sport} = this.props;

		return (
			<div key={`live-sport-${sport.id}`} className="events__table table-div">
				<EventHeader sport={sport}/>

				<div className="tbody">
					{this.props.children}
				</div>
			</div>
		);
	}
}

export default Sport;


// WEBPACK FOOTER //
// ./src/app/pages/LiveSoon/modules/Sport.js